<template>
  <table-layout title="محصولات">
    <template #buttons>
      <b-row>


        <router-link class="ml-2 mt-1" :to="{ name: 'TrashProduct' }">
          <b-button pill variant="danger"> سطل زباله</b-button>
        </router-link>


        <b-btn pill variant="info" class="ml-2" v-b-toggle.filters>
          فیلترها
        </b-btn>

        <router-link :to="{ name: 'CreateProduct' }" class="ml-2 mt-1">
          <b-button pill variant="purple"> ساخت محصول</b-button>
        </router-link>


        <router-link :to="{ name: 'DashboardWishList',params:{user_id:userId} }" class="ml-2 mt-1">
          <b-btn pill variant="secondary" class="ml-2">
            نمایش ایتم های موردعلاقه
          </b-btn>
        </router-link>

        <data-import-manager class="ml-2 mt-1" data-type="product" />


        <data-export class="ml-2 mt-1" data-type="product" />


        <LanguageSelectBox @changeLanguage="getProductItems" module-name="product" class="mx-4"/>

      </b-row>

    </template>
    <template #filters>
      <filters/>


    </template>

    <template #table>
      <table-items :items="products" :restoreState="false"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="productPaginationMeta" :on-change-page="changeProductsPage"/>
      </b-row>
    </template>


  </table-layout>
</template>

<script>
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout.vue";
import tableItems from "../../components/dashboard/product/tableItems.vue";
import Pagination from "../../components/dashboard/Pagination.vue";
import Filters from "../../components/dashboard/product/Filters";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";
import DataImportManager from "../../components/dashboard/DataImport/DataImportManager.vue";
import DataExport from "../../components/dashboard/DataExport/DataExport.vue";

export default {
  name: "Product",
  components: {DataExport, DataImportManager, TableLayout, tableItems, Pagination, Filters, LanguageSelectBox},
  data() {
    return {
      is_digital: false,
    }
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      productPaginationMeta: "Product/getPaginationMeta",
      userId: 'User/getUserId'
    }),
  },
  methods: {
    changeProductsPage(page) {
      const currentRouteQuery = this.$route.query
      this.$router.push({name: this.$route.name, query: {...currentRouteQuery, ...{page: page}}})
      this.$store.dispatch("Product/setDashboardProducts", page);
    },
    async getProductItems() {
      let page = 1
      if (this.$route.query.page != undefined) {
        page = this.$route.query.page;
      }
      this.$store.commit("Product/setFilters", {key: "sort", value: 'id,desc'});
      await this.$store.dispatch("Product/setDashboardProducts", page);
    },
  },
  async mounted() {
    await this.getProductItems();
  },
};
</script>